export enum ActionTypes {
    SET_CALCOVERRIDE = 'SET_CALCOVERRIDE'
}

export type ICalcOverrideActions = ISetCalcOverrideAction;

export interface ISetCalcOverrideAction {
    type: ActionTypes.SET_CALCOVERRIDE;
    data: boolean;
}
